import EventBus from "@/utils/EventBus";

export default function useModal() {
  function alert(message, options) {
    return new Promise((resolve) => {
      EventBus.emit("alert", {
        contents: message,
        onClose: resolve,
        title: options?.title,
        closeText: options?.closeText,
      });
    });
  }

  function confirm(message, options) {
    return new Promise((resolve) => {
      EventBus.emit("confirm", {
        contents: message,
        onSubmit: resolve,
        title: options?.title,
        confirmText: options?.confirmText,
        closeText: options?.closeText,
      });
    });
  }

  function share(value, options) {
    return new Promise((resolve) => {
      EventBus.emit("share", {
        value,
        onClose: resolve,
        title: options?.title,
        closeText: options?.closeText,
      });
    });
  }

  function showRestockNotificationFormModal(productId, options) {
    return new Promise((resolve) => {
      EventBus.emit("showRestockNotificationFormModal", {
        productId,
        productName: options?.productName,
        productMainImageUrl: options?.productMainImageUrl,
        useOption: options?.useOption,
        productOptionGroups: options?.productOptionGroups,
        productOptionCombines: options?.productOptionCombines,
        onClose: resolve,
      });
    });
  }

  function showQnaConfirmingPasswordFormModal(qnaId) {
    return new Promise((resolve) => {
      EventBus.emit("showQnaConfirmingPasswordFormModal", {
        qnaId,
        onSubmit: (data) => {
          resolve(data);
        },
        onClose: resolve,
      });
    });
  }

  function showQnaWritingFormModal({ productTextName, productId }) {
    return new Promise((resolve) => {
      EventBus.emit("showQnaWritingFormModal", {
        productTextName,
        productId,
        onSubmit: resolve,
        onClose: resolve,
      });
    });
  }

  function showQnaEditFormModal({
    productTextName,
    qnaId,
    qnaContent,
    qnaIsSecret,
  }) {
    return new Promise((resolve) => {
      EventBus.emit("showQnaEditFormModal", {
        productTextName,
        qnaId,
        qnaContent,
        qnaIsSecret,
        onSubmit: resolve,
        onClose: resolve,
      });
    });
  }

  function showReviewFormModal(reviewTarget, options) {
    return new Promise((resolve) => {
      EventBus.emit("showReviewFormModal", {
        reviewTarget,
        mainImage: options?.mainImage,
        productTextName: options?.textName,
        onSubmit: resolve,
        onClose: resolve,
      });
    });
  }

  function showReviewEditFormModal(reviewTarget) {
    return new Promise((resolve) => {
      EventBus.emit("showReviewEditFormModal", {
        reviewTarget,
        onSubmit: resolve,
        onClose: resolve,
      });
    });
  }

  function showOrderPhoneInquiryModal({
    callQnaName,
    callQnaNumber,
    callQnaTime,
  }) {
    return new Promise((resolve) => {
      EventBus.emit("showOrderPhoneInquiryModal", {
        callQnaName,
        callQnaNumber,
        callQnaTime,
        onSubmit: resolve,
        onClose: resolve,
      });
    });
  }

  function showOrderCancelFormModal({
    cancelShipId,
    cancelPopupType,
    cancelItemName,
  }) {
    return new Promise((resolve) => {
      EventBus.emit("showOrderCancelFormModal", {
        cancelShipId,
        cancelPopupType,
        cancelItemName,
        onSubmit: resolve,
        onClose: resolve,
      });
    });
  }

  function showOrderExchangeOrRefundFormModal({
    orderId,
    orderItemId,
    orderItemName,
  }) {
    return new Promise((resolve) => {
      EventBus.emit("showOrderExchangeOrRefundFormModal", {
        orderId,
        orderItemId,
        orderItemName,
        onSubmit: resolve,
        onClose: resolve,
      });
    });
  }

  function showOtpTokenModal() {
    return new Promise((resolve) => {
      EventBus.emit("showOtpTokenModal", {
        onSubmit: resolve,
        onClose: resolve,
      });
    });
  }

  return {
    alert,
    confirm,
    share,
    showRestockNotificationFormModal,
    showQnaConfirmingPasswordFormModal,
    showQnaWritingFormModal,
    showQnaEditFormModal,
    showReviewFormModal,
    showReviewEditFormModal,
    showOrderPhoneInquiryModal,
    showOrderCancelFormModal,
    showOrderExchangeOrRefundFormModal,
    showOtpTokenModal,
  };
}
